"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _formatSeconds = require("@devsta/format-seconds");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Duration(_ref) {
  var asset = _ref.asset;

  var _ref2 = asset || {},
      metaData = _ref2.metaData;

  if (!metaData) {
    return null;
  }

  try {
    var _JSON$parse = JSON.parse(metaData),
        duration = _JSON$parse.duration;

    return _react.default.createElement("p", null, "".concat(duration ? (0, _formatSeconds.getMinutes)(duration, {
      hideMillis: true
    }) : 'Unknown', " min"));
  } catch (_unused) {
    return null;
  }
}

var _default = (0, _commonReact.withAssetSelector)(Duration);

exports.default = _default;